<template>
  <RCard class="subscriptions">
    <AgGrid :options="gridOptions" :row-data="subscriptions">
      <template #header>
        <div class="text-subtitle-1 text-secondary-2 q-ml-sm q-mt-sm">Subscriptions</div>
      </template>
    </AgGrid>
  </RCard>
</template>

<script>
import * as apiTo from '@/modular-api'
import { getProp, periodRenderer } from '@lib/generic.utils'
// Libraries
import { mapState, mapActions } from 'vuex'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import { notAnyPriceCheck, notAnyValueCheck } from '@/ag-grid/utils/notAnyValue'
import { agPriceCol } from '@/ag-grid/ag-columns'

export default {
  components: {
    AgGrid
  },

  props: {
    id: [Number, String] // from route
  },

  computed: {
    ...mapState('product-show', ['subscriptions']),

    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/subscriptions/${params.data.id}`
              }
            }
          },

          {
            headerName: 'Detail',
            field: 'latest_period.name_reference',
            cellRenderer: notAnyValueCheck
          },

          {
            headerName: 'Latest period',
            comparator: (a, b, nodeA, nodeB) => {
              let ADate = new Date(getProp(nodeA, 'data.latest_period.start_date'))
              let A = ADate ? ADate.getTime() : 0
              let BDate = new Date(getProp(nodeB, 'data.latest_period.start_date'))
              let B = BDate ? BDate.getTime() : 0
              return A - B
            },
            cellRenderer: params => periodRenderer(params.data.latest_period),
            sort: 'desc'
          },

          agPriceCol('Final Price', 'latest_period.price', {
            cellRenderer: params => notAnyPriceCheck(params, 'latest_period.currency')
          }),

          agPriceCol('Price in Local Currency', 'latest_period.normalized_price', {
            cellRenderer: params => notAnyPriceCheck(params, 'latest_period.normalized_currency')
          })
        ]
      }
    }
  },

  created() {
    this.getAndSetSubscriptions()
  },

  methods: {
    ...mapActions('product-show', ['getAndSetSubscriptions'])
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.subscriptions {
  @include table-with-no-filters;
}
</style>
